import { useEffect, useState } from "react";
import TaskCreate from "./taskCreate";
import { ITaskIndex, ITasks } from "../../../../../models/master/task";
import {
  deleteTask,
  getTask,
  getTasks,
} from "../../../../../action/masters/taskActionCreator";
import { connect, useDispatch } from "react-redux";
import { setTasks } from "../../../../../store/slices/master/taskSlice";
import TaskEdit from "./taskEdit";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import ReactModal from "react-modal";
import { limit } from "../../../../../constants/pageBlocks";
import LoaderSpinner from "../../../../../common-components/loader";

const TasksOverview = (props: ITaskIndex) => {
  const { tasks, getTasks, task, getTask, deleteTask } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [dropdownState, setDropdownState] = useState<{
    [key: number]: boolean;
  }>({});
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isToggleButton = target.closest(".dropdown.dropstart a");
      const isToggleContent = target.closest(".dropdown-menu button");

      if (!isToggleButton && !isToggleContent) {
        setDropdownState({});
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (id: number, e?: React.MouseEvent) => {
    e?.stopPropagation();
    setDropdownState((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState).forEach((key) => {
        if (parseInt(key) !== id) {
          newState[parseInt(key)] = false;
        }
      });
      newState[id] = !newState[id];
      return newState;
    });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const editItem = (id: number) => {
    handleEditOpen();
    getTask(id);
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.deleteCheck);
    setItemToDelete(id);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const onConfirm = async () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      try {
        setLoading(true);
        setShowAlert(false);
        setIsDelete(false);
        await deleteTask(itemToDelete, setAlert);
      } finally {
        setLoading(false);
      }
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllTasks();
    }
  };

  const getAllTasks = () => {
    getTasks && getTasks(limit.five);
  };
  useEffect(() => {
    getAllTasks();
    return () => {
      dispatch(setTasks([]));
    };
  }, []);

  const handleViewALL = () => {
    navigate(ROUTER_URL.FACULTY_ALL_TASKS);
  };

  const getTaskStatusDisplayName = (status: number) => {
    switch (status) {
      case 1:
        return "Due";
      case 2:
        return "In Progress";
      case 3:
        return "Open";
      case 4:
        return "Hold";
      case 5:
        return "Completed";
      default:
        return "Unknown";
    }
  };

  return (
    <>
      <div className="card-wrap">
        <div className="title">
          <h2>Tasks Overview</h2>
          <a className="btn-link" onClick={handleViewALL}>
            View All
          </a>
        </div>
        <div className="">
          <div className="title">
            <h4 className="fw-semibold mb-2">
              {tasks && tasks.length > 0
                ? `${tasks.length} Active Tasks`
                : "No Active Tasks"}
            </h4>
            <a
              className="btn-link"
              data-bs-toggle="modal"
              data-bs-target="#createtask"
              style={{ cursor: "pointer" }}
              onClick={handleCreateOpen}
            >
              Create Tasks
            </a>
          </div>

          <ul className="tasks-list">
            {tasks &&
              tasks.length > 0 &&
              tasks.map((task: ITasks) => {
                return (
                  <li>
                    <div className="img">
                      <img src="/assets/images/profile03.jpg" alt="" />
                    </div>
                    <div className="desc">{task.name}</div>
                    <div className="actions">
                      <span
                        className={
                          task.order === 1
                            ? "high"
                            : task.taskCurrentStatus === 2
                            ? "mid"
                            : "low"
                        }
                      >
                        {getTaskStatusDisplayName(task.order)}
                      </span>
                      <div className="dropdown dropstart">
                        <a
                          className="btn-more btn-task"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={() => toggleDropdown(task.id ?? 0)}
                        >
                          <img
                            src="/assets/images/icon/dots-more.svg"
                            alt=""
                            className="img-more"
                          />
                        </a>
                        {dropdownState[task.id ?? 0] && (
                          <ul className="dropdown-menu show">
                            <li>
                              <a
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#edittask"
                                onClick={() => {
                                  editItem(task.id ?? 0);
                                  setDropdownState({});
                                }}
                              >
                                Edit
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                type="button"
                                onClick={() => {
                                  deleteItem(task.id ?? 0);
                                  setDropdownState({});
                                }}
                              >
                                Delete
                              </a>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
          <ReactModal
            isOpen={showCreate}
            onRequestClose={handleCreateClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            style={{
              content: {
                outline: "none",
              },
            }}
          >
            {
              <TaskCreate
                setShowCreate={handleCreateClose}
                getAllTasks={getAllTasks}
              />
            }
          </ReactModal>

          <ReactModal
            isOpen={showEdit}
            onRequestClose={handleEditClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            style={{
              content: {
                outline: "none",
              },
            }}
          >
            {
              <TaskEdit
                setShowEdit={handleEditClose}
                getAllTasks={getAllTasks}
                task={task}
              />
            }
          </ReactModal>
        </div>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      ></SweetAlert>
      {isLoading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  getTasks: (noOfItems?: number) => getTasks(noOfItems),
  getTask: (id: number) => getTask(id),
  deleteTask: (id: number, callBack: Function) => deleteTask(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    tasks: state.task?.tasks,
    task: state.task?.task,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TasksOverview);
